import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/channel.svg',
})
export class ChannelComponent {}
